<template>
  <div class="overview -page">
    <h2>Feed</h2>
    <p>soon..</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: { ...mapState("user", ["data"]) }
};
</script>
